// removed by extract-text-webpack-plugin
module.exports = {"app":"src-components----App-module---app---2tPeO","layout-wrapper":"src-components----App-module---layout-wrapper---1UTV1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App.module.scss
// module id = 106
// module chunks = 915738553496 35783957827783